<template>
    <div class="fluid">
        <h1 class="app-title">TERMO DE REGULARIZAÇÃO PARA PARCELAMENTO - TRP</h1>
        <b-card>
            <b-row no-gutters>
                <b-col md="12" no-gutters>
                    <form-wizard
                            ref="wizard"
                            nextButtonText="Próximo"
                            backButtonText="Anterior"
                            finishButtonText="Concluir"
                            title
                            subtitle
                            color="#0A9C70" >
                        <wizard-step
                                slot-scope="props"
                                slot="step"
                                :tab="props.tab"
                                :index="props.index"
                        ></wizard-step>
                        <tab-content
                                icon="fas fa-id-card"
                                class="mx-auto"
                                title="Indicar o Devedor e o tipo de TRP">
                            <Devedor
                                    ref="abaDevedor"
                                    :trp="trp"
                                    @atribuirDevedor="atribuirDevedor"
                            />
                        </tab-content>
                        <tab-content
                                icon="fas fa-balance-scale"
                                class="mx-auto"
                                title="CDAs ajuizadas pendentes" >
                            <TabelaPesquisas ref="abaTabela"
                                             :trp="trp"
                                             :cdasSelecionadas="cdasSelecionadas"
                                             @prevTab="prevTab"
                                             @nextStep="nextStep"
                                             @forceNextStep="forceNextStep"
                                             @selecionarCdas="selecionarCdas"
                                             @atribuirFiltros="atribuirFiltros"
                                             @openCloseFilterPopup="openCloseFilterPopup"
                                             @closeFilterPopup="closeFilterPopup"
                                             @atribuirDevedor="atribuirDevedor" />
                        </tab-content>
                        <tab-content
                                icon="fas fa-edit"
                                class="mx-auto"
                                title="Emitir e/ou Assinar o TRP">
                            <ConfirmarGeracao ref="abaConfirmar"
                                              :trp="trp"
                                              :cdasSelecionadas="cdasSelecionadas"/>
                        </tab-content>
                        <tab-content
                                icon="fas fa-money-check-alt"
                                class="mx-auto"
                                title="TRP Emitido">
                            <Conclusao ref="abaConcluir"
                                       :trp="trp"
                                       :cdasSelecionadas="cdasSelecionadas"
                                       :retornoSalvar="retornoSalvar"
                                       :nova="trp.codRequisicaoProtesto == null"/>
                        </tab-content>

                        <template slot="footer" slot-scope="props" class="pb-0">
                            <hr class="mt-0 mb-2"/>
                            <div class="row justify-content-between">
                                <b-col sm="12" md="2">
                                    <b-button
                                            v-if="props.activeTabIndex == 2"
                                            @click="prevTab"
                                            variant="secondary" >
                                        <i class="fa fa-arrow-left"></i> Anterior
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="2" class="text-right" v-if="props.activeTabIndex == 0">
                                    <b-button
                                            id="btnProxima"
                                            @click="nextStep"
                                            :disabled="!validarProxima()"
                                            variant="primary">
                                        Próxima
                                        <i class="fa fa-arrow-right"></i>
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="2" class="text-right" v-if="props.activeTabIndex == 3">
                                    <b-button class="finish-button" variant="success" @click="sair">
                                        Concluir
                                        <i class="fas fa-flag-checkered"></i>
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="6" class="text-right" v-if="props.activeTabIndex == 2">
                                    <b-button variant="secondary" @click="sair" class="mr-2">
                                        <i class="fas fa-sign-out-alt"></i>
                                        Sair Sem Emitir o TRP
                                    </b-button>
                                    <b-button variant="warning" @click="salvar()"
                                            :title="administrativo ? ' A emissão e assinatura do TRP é exclusiva dos usuários de perfil Procurador.' : ''"
                                            :disabled="administrativo">
                                        <i class="fa fa-file-pdf"></i>
                                        Emitir e Assinar o TRP
                                    </b-button>
                                </b-col>
                            </div>
                        </template>
                    </form-wizard>
                </b-col>
            </b-row>
        </b-card>
        <CompLoading ref="loading"/>
        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
    </div>
</template>

<script>
    import {FormWizard, TabContent, WizardStep} from 'vue-form-wizard';
    import formatarMixins from '../../mixins/formatarMixins';

    import axios from 'axios';
    import 'vue-form-wizard/dist/vue-form-wizard.min.css';
    import Devedor from "./components/Devedor";
    import TabelaPesquisas from "./components/TabelaPesquisas";
    import CompLoading from "../shared/components/CompLoading";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import ConfirmarGeracao from "./components/ConfirmarGeracao";
    import Conclusao from "./components/Conclusao";

    export default {
        mixins: [ formatarMixins ],
        components: {
            Devedor,
            Conclusao,
            ConfirmarGeracao,
            TabelaPesquisas,
            FormWizard,
            TabContent,
            WizardStep,
            CompLoading,
            CompFiltroGrid
        },
        data() {
            return {
                urlApi: null,
                token: null,
                administrativo: false,
                cdasSelecionadas: [],
                filtro: {
                },
                trp: {
                    tipoTrp: null,
                    devedor: {
                        codContribuinte: null,
                        documento: null,
                        nome: null
                    },
                    cdas: []
                },
                retornoSalvar: {
                    id: null,
                    arquivo: null
                }
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            },
            confirmarValido() {
                return !this.verificarValorVazio(this.trp.setor) &&
                        this.$refs.abaConfirmar.validarObservacao() && this.$refs.abaConfirmar.validarEmailPreenchido();
            },
        },
        methods: {
            atribuirDevedor(devedor) {
                if(devedor == null) {
                    this.trp.devedor = {
                        codContribuinte: null,
                        documento: null,
                        nome: null
                    };
                } else {
                    this.trp.devedor = devedor;
                }
            },
            validarProxima() {
                if(this.$refs.wizard != null && this.$refs.wizard.activeTabIndex == 0
                    && (this.$refs.abaDevedor == null || !this.$refs.abaDevedor.validarForm())) {
                    return false;
                }

                return true;
            },
            acionarEnter(e) {
                if(e.key == 'Enter') {
                    if(this.$refs.wizard.activeTabIndex == 0 && this.$refs.abaDevedor != null && this.$refs.abaDevedor.validarForm()) {
                        document.getElementById("btnProxima").click();
                    } else if(this.$refs.wizard.activeTabIndex == 1 && this.cdasSelecionadas.length > 0) {
                        document.getElementById("btnProximaTabela").click();
                    }
                }
            },
            acionarEnterDelay(e) {
                if(!this.$refs.abaDevedor.modalOpen() && e.key == 'Enter' && e.path == undefined || e.path[0].type == undefined || e.path[0].type != 'button') {
                    setTimeout(()=>{
                        this.acionarEnter(e);
                    }, 200);
                }
            },
            selecionarCdas(cdas) {
                this.cdasSelecionadas = cdas;
            },
            atribuirFiltros(filtros) {
                this.filtro = filtros;
            },
            openCloseFilterPopup(event) {
                this.$refs.compFiltro.openCloseFilterPopup(event);
            },
            closeFilterPopup() {
                this.$refs.compFiltro.closeFilterPopup();
            },
            filtrarResultados(limpar) {
                this.$refs.abaTabela.filtrarResultados(limpar);
            },
            ordenarResultados(order) {
                this.$refs.abaTabela.ordenarResultados(order);
            },
            forceNextStep() {
                this.$refs.wizard.nextTab();
            },
            nextStep() {
                this.$store.commit("setMessages", {});
                if(this.$refs.wizard.activeTabIndex == 0) {
                    this.$refs.wizard.nextTab();
                    this.cdasSelecionadas = [];
                    this.$refs.abaTabela.pesquisaInicial = true;
                    this.$refs.abaTabela.limparFiltros();
                } else if(this.$refs.wizard.activeTabIndex == 1) {
                    let possui = false;
                    for(let i = 0; i < this.cdasSelecionadas.length; i++) {
                        if(this.cdasSelecionadas[i].statusTrp == 'Ativa') {
                            possui = true;
                            break;
                        }
                    }

                    if(possui) {
                        this.$refs.abaTabela.abrirModalAvancar();
                    } else {
                        this.$refs.wizard.nextTab();
                    }
                }
                window.scrollTo(0,0);
            },
            prevTab() {
                this.$store.commit("setMessages", {});

                if(this.$refs.wizard.activeTabIndex == 2) {
                    this.$refs.abaTabela.consultar();
                }
                this.$refs.wizard.prevTab();
            },
            atribuirListaCda(items) {
                this.trp.cdas = items;
            },
            async voltar() {
                this.$refs.wizard.reset();
            },
            sair() {
                this.$router.push({path: '/home'});
            },
            openPdfWithAuth(pdfUrl, authToken) {
                // 1. Fetch the PDF as a blob with the Authorization header
                fetch(pdfUrl, {
                    headers: {
                        'Authorization': authToken,
                    },
                }).then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.blob();
                }).then(blob => {
                    // 2. Create a local URL from the blob
                    const fileURL = window.URL.createObjectURL(blob);
                    // 3. Set src element to the new URL
                    document.getElementById('guiaPdf').src = fileURL;
                }).catch(error => {
                    console.error('Error fetching the PDF:', error);
                });
            },
            async salvar() {
                let trpTemp = {
                    ... this.trp,
                    cdas: this.cdasSelecionadas
                };

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/trp/emitirAssinar`, trpTemp, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.retornoSalvar = response.data;
                    this.openPdfWithAuth(`${this.urlApi}/v1/trp/obterArquivoTrp/publico/${this.retornoSalvar.id}/${this.retornoSalvar.arquivo}`, this.token);                    
                    this.$refs.wizard.nextTab();
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.administrativo = false;
            let userData = JSON.parse(this.$store.getters.getUser);
            if (userData.groups) {
                for (let i = 0; i < userData.groups.length; i++) {
                    if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR') {
                        this.administrativo = false;
                        break;
                    }
                    if(userData.groups[i] == 'SFEPGE-TESOUREIRO') {
                        this.administrativo = false;
                        break;
                    }
                    if(userData.groups[i] == 'SFEPGE-PROCURADOR') {
                        this.administrativo = false;
                        break;
                    }
                    if(userData.groups[i] == 'SFEPGE-ADMINISTRATIVO') {
                        this.administrativo = true;
                    }
                }
            }

            setTimeout(()=>{
                document.getElementsByClassName('cpfCnpj')[0].focus();
                window.addEventListener("keypress", this.acionarEnterDelay);
            }, 500);
        },
    }
</script>
